import React from 'react';
import classnames from 'classnames';
import cloneDeep from 'lodash/cloneDeep';

import FullScreenImage from '../../../../../../../../components/FullScreenImage';
import EditableCaption from '../../../../../../components/EditableCaption';

const onCaptionChange = (itemId, dispatch) => (text) => {
  dispatch('UPDATE_ITEM_DATA', {
    _id: itemId,
    caption: text
  });
};

const editorOptions = {
  toolbar: {
    buttons: [
      'bold',
      'italic',
      'superscript',
      'subscript',
      { name: 'justifyLeft', contentDefault: '<i class="icon-paragraph-left"></i>' },
      { name: 'justifyCenter', contentDefault: '<i class="icon-paragraph-center"></i>' },
      { name: 'justifyRight', contentDefault: '<i class="icon-paragraph-right"></i>' },
      { name: 'anchor', contentDefault: '<i class="icon-link"></i>' },
      'unorderedlist',
      'orderedlist'
    ]
  }
};

function renderCaption(item, editable, dispatch) {
  const caption = item.caption;
  const captionClassSet = classnames('block-image__caption brand--body brand--linkColor', {
    'hide-placeholder': caption
  });
  if (!caption && !editable) {
    return null;
  }
  const clonedEditorOptions = cloneDeep(editorOptions);
  Object.assign(clonedEditorOptions, { disableReturn: true });

  return (
    <EditableCaption
      wrapperClassName={captionClassSet}
      text={caption}
      placeholder="Add a caption"
      component="figcaption"
      editable={editable}
      onChange={onCaptionChange(item._id, dispatch)}
      editorOptions={clonedEditorOptions}
    />
  );
}

export default (props) => {
  const editable = props.editable;
  const lesson = props.lesson;
  const item = lesson.items[0];
  const size = item.media.image.size || 100;

  const settings = lesson.settings;
  const { paddingBottom, paddingTop, backgroundColor, zoomOnClick } = settings;

  const style = {
    paddingBottom: paddingBottom * 10,
    paddingTop: paddingTop * 10,
    backgroundColor,
    width: `${size}%`,
    margin: '0 auto'
  };

  const enableZoom = !editable && zoomOnClick;

  return (
    <div className="block-image block-image--hero" style={style}>
      <div className="">
        <div className="">
          <div className="">
            <figure className="block-image__figure">
              <div className="block-image__image">
                <FullScreenImage
                  src={item.media.image.src}
                  enableZoom={enableZoom}
                  alt={item.media.alt || ''}
                  placeHolder={item.media.image.placeHolder}
                />
              </div>
              {renderCaption(item, props.editable, props.dispatch)}
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
};
